/**
 * Pluggable composer that attaches edit callbacks per mapped widget type.
 * Each widget package registers its factory here; section components stay generic.
 */

import { checklistWidgetFactory } from './checklist/checklistWidgetFactory';
import { noteWidgetFactory } from './note/note-widget.factory';

const WIDGET_EDIT_FACTORIES = {
  [checklistWidgetFactory.type]: checklistWidgetFactory.attachEditCallbacks,
  [noteWidgetFactory.type]: noteWidgetFactory.attachEditCallbacks,
};

/**
 * Applies registered per-widget-type edit factories.
 *
 * @param {object[]} widgets - Mapped UI widgets (`type` / `id` / `props`)
 * @param {Record<string, object>|undefined} handlersByType - Handlers keyed by UI widget type
 * @returns {object[]}
 */
export const withEditableWidgetCallbacks = (widgets = [], handlersByType) => {
  if (!handlersByType) {
    return widgets;
  }

  return widgets.map((widget) => {
    const attach = WIDGET_EDIT_FACTORIES[widget?.type];
    const handlers = handlersByType[widget?.type];

    if (!attach || !handlers || !widget?.id) {
      return widget;
    }

    return attach(widget, handlers);
  });
};
